<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-05 17:34:40
 * @LastEditTime: 2019-08-22 14:43:44
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div>
     <el-tabs v-model="activeName" type="card"  @tab-click="handleClick">
          <el-tab-pane label="出货统计（经销商/门店）" name="2">
            <el-form ref="form" :model="form" label-width="120px" :inline="true">
              <el-form-item label="出货时间:" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form.start_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form.end_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="出货单号:">
                <el-input v-model="form.stock_out_sn" clearable ></el-input>
              </el-form-item>
              <el-form-item label="产品编号:">
                <el-input v-model="form.product_sn" clearable ></el-input>
              </el-form-item>
              <el-form-item label="产品名称:">
                <el-input v-model="form.product_name" clearable ></el-input>
              </el-form-item>
              <el-form-item label="经销商/门店信息:" prop="to_sn">
                <el-col :span="18">
                  <el-input v-model="form.to_sn"  class="readonlyclass"></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 20px">
                  <el-button type="primary" @click='selectRoleDialog=true'>选择</el-button>
                </el-col>
              </el-form-item>
              <el-form-item style="margin-left: 100px">
                <el-button type="primary" @click="onSearch()">搜索</el-button>
                <el-button type="primary" @click="onExport()">导出</el-button>
              </el-form-item>
            </el-form>
            <div style="padding-left:50px">
              出货总数
              <span style="color:#f04635">{{total}}</span>
            </div>
            <el-table
              ref="multipleTable"
              :data="tableData"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column  label="序号" fixed><template slot-scope="scope">{{scope.$index}}</template></el-table-column>
              <el-table-column prop='to_name' label="经销商/门店名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop='to_sn' label="经销商/门店编号" show-overflow-tooltip></el-table-column>
              <el-table-column prop='real_stock_out_num' label="出货数量" show-overflow-tooltip></el-table-column>

              <el-table-column prop label="操作" width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click='detail(scope.row)'>明细</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="出货统计(产品)" name="3">
            <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
              <el-form-item label="入库时间:" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form1.start_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form1.end_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="出货单号:">
                <el-input v-model="form1.stock_out_sn" clearable ></el-input>
              </el-form-item>
              <el-form-item label="产品编号:">
                <el-input v-model="form1.product_sn" clearable ></el-input>
              </el-form-item>
              <el-form-item label="产品名称:">
                <el-input v-model="form1.product_name" clearable ></el-input>
              </el-form-item>
              <el-form-item label="经销商/门店信息:" prop="to_sn">
                <el-col :span="18">
                  <el-input v-model="form1.to_sn"  class="readonlyclass"></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 20px">
                  <el-button type="primary">选择</el-button>
                </el-col>
              </el-form-item>
              <el-form-item style="margin-left: 100px">
                <el-button type="primary" @click="onSearch()">搜索</el-button>
                <el-button type="primary" @click="onExport()">导出</el-button>
              </el-form-item>
            </el-form>
            <div style="padding-left:50px">
              出货总数
              <span style="color:#f04635">{{total}}</span>
            </div>
            <el-table
              ref="multipleTable"
              :data="tableData1"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="序号" fixed><template slot-scope="scope">{{scope.$index}}</template></el-table-column>
              <el-table-column prop='product_sn' label="产品编号" show-overflow-tooltip></el-table-column>
              <el-table-column prop='product_name' label="产品名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop='product_specs' label="产品规格" show-overflow-tooltip></el-table-column>
              <el-table-column prop='real_stock_out_num' label="出货数量" show-overflow-tooltip></el-table-column>
              <el-table-column prop='real_stock_out_num' label="操作" width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click='detail(scope.row)'>明细</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="pageNo1"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize1"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
            <!--选择经销商/门店-->
        <selectRole
                v-if="selectRoleDialog"
                v-on:handleClose='selectRoleDialog = false'
                @pushData="getSelectinfo">
        </selectRole>
          <el-dialog
                :visible.sync="detailDialog"
                width="40%"
                title='查看明细'
                 v-on:handleClose='detailDialog = false,pageSize2=20,pageNo2=1'
                >
                      <el-button  size="small" @click="exportDetail()" style='margin-bottom:10px;'>导出明细</el-button>
            <el-table
                  :data="tableData2"
                  style="width: 100%"
                  border
                    v-loading="loading"
                 >
                          <el-table-column
                                  prop="stock_out_sn"
                                  label="出货单号"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="to_sn"
                                  label="收货经销商/门店编号"
                                  v-if='activeName==3'

                                >
                          </el-table-column>
                          <el-table-column
                                  prop="to_name"
                                  label="收货经销商门店"
                                  v-if='activeName==3'
                                 
                                 >
                          </el-table-column>
                              <el-table-column
                                  prop="product_sn"
                                  label="产品编号"
                                  v-if='activeName==2'

                                >
                          </el-table-column>
                          <el-table-column
                                  prop="product_name"
                                  label="产品名称"
                                  v-if='activeName==2'
                                 
                                 >
                          </el-table-column>
                             <el-table-column
                                  prop="product_specs"
                                  label="产品规格"
                                  v-if='activeName==2'
                                 
                                 >
                          </el-table-column>
                           <el-table-column
                                  prop="stock_out_time"
                                  label="出货时间"
                                  show-overflow-tooltip>
                          </el-table-column>
                          <el-table-column
                                  prop="real_stock_out_num"
                                  label="产品数量"
                                  show-overflow-tooltip>
                          </el-table-column>
                          <el-table-column
                                  prop="logistics_code"
                                  label="物流码"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="code_name"
                                  label="标签类型"
                          fixed="right"

                                 >
                          </el-table-column>
                        
                    </el-table>
                                   <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination>
                    </el-dialog>
    </div>
</template>

<script>
    import selectRole from '@/common/selectRole';

export default {
    name:'my',
    data(){
        return{
            selectRoleDialog:false,
                form1:{
                    to_sn:"",
                    end_time:"",
                    start_time:"",
                    stock_out_sn:"",
                    product_sn:"",
                    product_name:"",
                    to_type:"",
                    keywords:""
                },
                form:{
                    to_sn:"",
                    end_time:"",
                    start_time:"",
                    stock_out_sn:"",
                    product_sn:"",
                    product_name:"",
                    to_type:"",
                    keywords:""
                },
                activeName:'2',
                  loading:false,
                     pageNo1: 1,
                pageSize1: 20,
                totalSize1: 0,
                tableData:[],
                tableData1:[],
                tableData2:[],
                total:0,
                      pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                    pageNo2: 1,
                pageSize2: 20,
                totalSize2: 0,
                detailDialog:false,
                detailData:{}
        }
    },
    methods:{
        onSearch(){
            this.loading=true
            if(this.activeName==2){
                if(this.form.start_time){
                        this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form.end_time){
                        this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    } 
                    this.$get('logistics','/stocks.outstocks',{
                        ...this.form,
                        per_page:this.pageSize,
                        page:this.pageNo
                        
                    }).then(res=>{
                    this.totalSize=res.meta.total
                    this.tableData=res.data
                    this.total=res.real_stock_out_num
                    this.loading=false
                })
            }else{
               if(this.form1.start_time){
                        this.form1.start_time = this.moment(this.form1.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form1.end_time){
                        this.form1.end_time = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                    } 
                       this.$get('logistics','/stocks.outproducts',{
                        ...this.form1,
                           per_page:this.pageSize1,
                        page:this.pageNo1
                    }).then(res=>{
                    this.totalSize1=res.meta.total
                    this.tableData1=res.data
                    this.total=res.real_stock_out_num

                    this.loading=false
                })
            }
        },
        onExport(){
                      let url = '',access_tokens = localStorage.getItem('access_token');
                 
                    if(this.activeName==2){
                           let beginstr = '', endstr = '';
                    if(this.form.start_time){
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form.end_time){
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    } 
                
                          window.open(process.env.VUE_APP_URL
                        +'/stocks.outstocks.export?start_time='+beginstr+
                        '&end_time='+endstr+
                        '&stock_out_sn='+this.form.stock_out_sn+
                        '&product_sn='+this.form.product_sn+
                        '&product_name='+this.form.product_name+
                        '&to_type='+this.form.to_type+
                        '&to_sn='+this.form.to_sn+

                       '&lang=' + '' +'&is_export=1'+
                       '&keywords='+this.form1.keywords
                       +'&signature='+ this.$md5(access_tokens)
                    )
                    }else{
                        let beginstr = '', endstr = '';
                    if(this.form1.start_time){
                        beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form1.end_time){
                        endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                    }
                          window.open(process.env.VUE_APP_URL
                        +'/stocks.outproducts.export?start_time='+beginstr+
                        '&end_time='+endstr+
                        '&stock_out_sn='+this.form1.stock_out_sn+
                        '&product_sn='+this.form1.product_sn+
                        '&product_name='+this.form1.product_name+
                        '&to_type='+this.form1.to_type+
                        '&to_sn='+this.form1.to_sn+
                       '&lang=' + '' +'&is_export=1'+
                       '&keywords='+this.form1.keywords
                       +'&signature='+ this.$md5(access_tokens)
                    )
                    }
        
        },
        detail(data){
                this.detailDialog=true
        if(data){
            this.detailData=data
        }
                        this.loading=true
                        this.tableData2=[]
            if(this.activeName==2){
                    this.$get('logistics','/stocks.outstocks/datas',{
                        per_page:this.pageSize2,
                        page:this.pageNo2,
                        to_type:this.detailData.to_type,
                        to_sn:this.detailData.to_sn
                    }).then(res=>{
                        this.tableData2=res.data
                        this.totalSize2=res.meta.total
                        this.loading=false
                    })
            }else{
                     this.$get('logistics','/stocks.outproducts/datas',{
                        per_page:this.pageSize2,
                        page:this.pageNo2,
                        product_sn :this.detailData.product_sn 
                    }).then(res=>{
                        this.tableData2=res.data
                        this.totalSize2=res.meta.total
                        this.loading=false
                    })
            }
        },
        exportDetail(){
            let access_tokens = localStorage.getItem('access_token');
                
                    if(this.activeName==2){
                         window.open(process.env.VUE_APP_URL
                        +'/stocks.outstocks/datas.export'+
                        '?to_type='+this.detailData.to_type +
                        '&to_sn='+this.detailData.to_sn +
                       '&lang='+''+'&is_export=1'
                       +'&signature='+ this.$md5(access_tokens)
                    )
                    }else{
                             window.open( process.env.VUE_APP_URL
                        +'/stocks.outproducts/datas.export'+
                        '?product_sn='+this.detailData.product_sn +                      
                       '&lang='+''+'&is_export=1'
                       +'&signature='+ this.$md5(access_tokens)
                    )
                    }
        },
        getSelectinfo(val){
            if(this.activeName==2){
                 if (val.dealer_sn) {
                        this.form.to_sn = val.dealer_sn;
                        this.form.to_type = 2;
                    } else {
                        this.form.to_sn = val.shop_sn;
                        this.form.to_type = 3;
                    }
            }else{
                 if (val.dealer_sn) {
                        this.form1.to_sn = val.dealer_sn;
                        this.form1.to_type = 2;
                    } else {
                        this.form1.to_sn = val.shop_sn;
                        this.form1.to_type = 3;
                    }
            }
        },
                getLastMonth() {
                    var now = new Date();
                    var year = now.getFullYear();//getYear()+1900=getFullYear()
                    var month = now.getMonth() + 1;//0-11表示1-12月
                    var day = now.getDate();
                    var dateObj = {};
                    if (parseInt(month) < 10) {
                        month = "0" + month;
                    }
                    if (parseInt(day) < 10) {
                        day = "0" + day;
                    }

                    dateObj.now = year + '-' + month + '-' + day;

                    if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
                        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
                        return dateObj;
                    }

                    var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
                    if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
                        dateObj.last = year + '-' + month + '-01';
                        return dateObj;
                    }

                    if (parseInt(month) <= 10) {
                        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    } else {
                        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    }

                },
                  handleSizeChange1(val) {
            this.pageSize1 = val;
            this.pageNo1 = 1;
            this.onSearch();
        },
        handleCurrentChange1(val) {
            this.pageNo1 = val;
            this.onSearch();
        },
         handleSizeChange(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.onSearch();
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.onSearch();
        },
            handleSizeChange2(val) {
            this.pageSize2 = val;
            this.pageNo2 = 1;
            this.detail();
        },
        handleCurrentChange2(val) {
            this.pageNo2 = val;
            this.detail();
        },
        handleClick(){
            this.onSearch()
        }
    },
    created(){
              this.form.start_time = this.getLastMonth().last;
            this.form.end_time = this.getLastMonth().now;
                  this.form1.start_time = this.getLastMonth().last;
            this.form1.end_time = this.getLastMonth().now;
           this.onSearch()
    },
    components:{
        selectRole
    }
}
</script>

